import { render, staticRenderFns } from "./ShowDetails.vue?vue&type=template&id=dd2bd0ae&scoped=true"
import script from "./ShowDetails.vue?vue&type=script&lang=js"
export * from "./ShowDetails.vue?vue&type=script&lang=js"
import style0 from "./ShowDetails.vue?vue&type=style&index=0&id=dd2bd0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2bd0ae",
  null
  
)

export default component.exports